import React from 'react'

import { Button } from '@gousto-internal/citrus-react'
import Svg from 'Svg'
import Immutable from 'immutable'

import routes from 'config/routes'

import css from './ReferAFriend.css'

type ReferralDetails = {
  referralCount: string
  referralCredit: string
}

type ReferAFriendProps = {
  referralDetails?: Immutable.Map<string, any>
  redirect: (path: string) => void
}

export const ReferAFriend: React.FC<ReferAFriendProps> = ({
  referralDetails = Immutable.Map({}),
  redirect,
}) => {
  const { referralCount, referralCredit } =
    referralDetails && (referralDetails.toJS() as ReferralDetails)

  const onClick = (): void => {
    redirect(routes.client.myReferral)
  }

  return (
    <div className={css.rafWrapper}>
      <div className={css.rafImageWrapper} />
      <div className={css.rafStampsWrapper}>
        <div className={css.rafStampDetails}>
          <div className={css.rafStamp}>
            <p className={css.rafDetailsValue} data-testid="referralCount">
              {referralCount}
            </p>
            <Svg fileName="icon-stamp-full" className={css.iconStamp} />
          </div>
          <p className={css.rafDetailsLabel}>
            Friends who have signed up using your Gousto referral
          </p>
        </div>
        <div className={css.rafStampDetails}>
          <div className={css.rafStamp}>
            <p className={css.rafDetailsValue} data-testid="referralCredit">
              £{referralCredit}
            </p>
            <Svg fileName="icon-stamp-full" className={css.iconStamp} />
          </div>
          <p className={css.rafDetailsLabel}>
            Gousto credit you&#39;ve earned so far from inviting your friends
          </p>
        </div>
      </div>
      <div className={css.shareExperience}>
        <h3 className={css.shareHeading}>Share the Gousto experience</h3>
        <p>Refer a friend – and you both save</p>
        <Button onClick={onClick} data-testid="inviteMoreFriends">
          Invite More Friends
        </Button>
      </div>
    </div>
  )
}
